<div class="relative p-6 bg-white dark:bg-gray-900 sm:p-0">
  <div class="relative z-1 flex min-h-screen flex-col items-center justify-center overflow-hidden p-6">

    <!-- ===== Common Grid Shape End ===== -->

    <div>
      <div class="mx-auto w-full max-w-[400px] text-center sm:max-w-[700px]">
        <div>
          <app-anim-email></app-anim-email>
        </div>
        <h2 class="text-title-md xl:text-title-md mb-2 font-bold text-gray-800 dark:text-white/90">
          ¡Registro exitoso!
        </h2>
        <p class="mt-6 mb-6 text-base text-gray-700 sm:text-lg dark:text-gray-400">
          Se ha enviado un mensaje de confirmación a tu correo electrónico.
          Por favor, revisa tu bandeja de entrada para continuar con el registro
          y configurar completamente tu cuenta.
        </p>

        <a [routerLink]="['/auth/signin']" routerLinkActive="router-link-active"
          class="flex items-center justify-center w-full px-4 py-3 text-sm font-medium text-white transition rounded-lg bg-brand-500 shadow-theme-xs hover:bg-brand-600 cursor-pointer">
          Iniciar Sesión
        </a>
      </div>

      <!-- Footer -->
      <p class="absolute bottom-6 left-1/2 -translate-x-1/2 text-center text-sm text-gray-500 dark:text-gray-400">
        © <span id="year">2025</span> - CitaLink Pro
      </p>
    </div>
  </div>
</div>
